import React from "react";
import PropTypes from "prop-types";

import { MaterialUIGridContainer } from "core/MaterialUI";
import Button from "core/Button";
import { PurchaseLinkGridItem, CancelLink, CancelLinkGridItem } from "./styles";

const FormButtons = ({
    isSubmitDisabled,
    showSavedCard,
    submitFormWithNewCardInfo,
    submitFormWithSavedCardInfo,
    submitText,
    cancelText,
    cancelLink,
    loading
}) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={0}
            tabletMaxPadding={0}
            desktopMinPadding={0}
            alignItems="center"
        >
            <PurchaseLinkGridItem item sm={9} md={6} lg={6}>
                <Button
                    isProcessing={loading}
                    styleType="cta"
                    width="100%"
                    disabled={isSubmitDisabled}
                    onClick={
                        showSavedCard
                            ? submitFormWithSavedCardInfo
                            : submitFormWithNewCardInfo
                    }
                    // TODO: refactor onClick here so i can use this component for prepaid
                >
                    {submitText ? submitText : "Purchase"}
                </Button>
            </PurchaseLinkGridItem>

            <CancelLinkGridItem item sm={3} md={6} lg={6}>
                <CancelLink to={cancelLink}>
                    {cancelText ? cancelText : "Cancel"}
                </CancelLink>
            </CancelLinkGridItem>
        </MaterialUIGridContainer>
    );
};

FormButtons.propTypes = {
    isSubmitDisabled: PropTypes.bool.isRequired,
    showSavedCard: PropTypes.bool.isRequired,
    submitFormWithNewCardInfo: PropTypes.func.isRequired,
    submitFormWithSavedCardInfo: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    cancelText: PropTypes.string,
    cancelLink: PropTypes.string.isRequired
};

export default FormButtons;
